module.exports = __webpack_public_path__ + "img/technics-build.bae9db53.png";